import { getFlowTypeWithIntend, getUrlName } from '../../common/Helpers';
import { getChannelId } from '../../../services/HttpService';

/**
 * Page name mapping for VoiceBot — backend / CES routing (vzdl.page alignment).
 */
export const getVoiceBotPageName = () => {
  /* istanbul ignore next */
  const pageName = getUrlName(window.location?.pathname || '');
  const pageKey = String(pageName || '').toLowerCase();
  const pageMap = {
    progressiveplan: 'FWA Plans Page',
    streamlineordering: 'FWA Streamline Ordering',
    addons: 'FWA Addons',
    setup: 'FWA Device Setup',
    cart: 'FWA Cart',
    expresscheckout: 'FWA Express Checkout',
    contactinfo: 'FWA Contact Info',
    shipping: 'FWA Shipping',
    creditcheck: 'FWA Credit Check',
    payment: 'FWA Payment',
    orderreview: 'FWA Order Review',
    appointment: 'FWA Appointment',
    broadbandfacts: 'FWA Broadband Facts',
  };
  return pageMap[pageKey] || `FWA ${pageName || 'Home'}`;
};

/**
 * Cookies + vzdl sync for channel / flow (shell / browse parity).
 */
export function syncVoiceBotPageContextToShell() {
  if (typeof window === 'undefined') return { page: '', channel: '', flow: '' };
  const channel = getChannelId();
  const flow = getFlowTypeWithIntend();
  const page = getVoiceBotPageName();
  if (flow) {
    document.cookie = `flowName=${encodeURIComponent(flow)}; path=/`;
    document.cookie = `flow=${encodeURIComponent(flow)}; path=/`;
  }
  if (window.vzdl?.page) {
    window.vzdl.page = {
      ...window.vzdl.page,
      name: page,
      flow: flow || window.vzdl.page.flow,
      displayChannel: channel || window.vzdl.page.displayChannel,
    };
  }
  return { page, channel, flow };
}
